import React, { useEffect, useRef, useState } from "react";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import moment from "moment";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import $ from "jquery";
import { Client_Search } from "../../Configuration/API_URL";
import Loader from "../../Components/Common/Loader";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import { Col, Row } from "react-bootstrap";
import ContractListTable, {
  getRowSelectionKey,
  getFileNameFromSelectionKey,
} from "../../Components/ReportTables/ContractListTable";
import ContractTableHeader from "../../Components/ReportTables/ContractTableHeader";
import { Constants, REPORT_TYPES } from "../../CommonMethhods/Constants";
import TodateComponent from "./TodateComponent";
import FromdateComponent from "./FromdateComponent";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SmallLoader from "../../Components/Common/smallLoader";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import DurationChangeComponent from "./DurationChangeComponent";
import { useDebounce } from "../../Components/useDebounce";
import axiosInstance from "../../CommonMethhods/axiosInstance";
import { useDownloadAll } from "./useStatementReport";

function ContractListSidebar() {
  const UAT_LIVE = JSON.parse(process.env.REACT_APP_UAT_URL);

  const storeToken = localStorage.getItem("ssoToken");
  // const [fileType, setFileType] = useState("grid");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [checkDate, setCheckDate] = useState(false);
  const [clientNameError, setClientNameError] = useState(false);
  const [seg, setSeg] = useState("stocks");
  const [data, setData] = useState([]);
  const [errorResp, setErrorResp] = useState("");
  const [nameError, setNameError] = useState("");
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [scroll, setScroll] = useState(false);
  const [clientName, setClientName] = useState("");
  const [clientCode, setClientCode] = useState("");
  const [serverError, setServerError] = useState(false);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [userFriendList, setUserFriendList] = useState([]);
  const [userFriendlyName, setUserFriendlyName] = useState([]);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [mailError, setMailError] = useState("");
  const [customShow, setCustomShow] = useState(false);
  const [selectDuration, setSelectDuration] = useState("");
  const [selectedReportType, setSelectedReportType] = useState("");
  const [appliedReportType, setAppliedReportType] = useState("");
  const [reportTypeError, setReportTypeError] = useState("");
  const [showEmailConfirmation, setShowEmailConfirmation] = useState(false);

  const { isDownloading, downloadAllStatementReport } = useDownloadAll();

  let newArr = [];

  // Set to true right when a client is picked from the dropdown, so the
  // debounce effect below doesn't treat that selection as freshly typed
  // search text and re-open the suggestions list on top of it.
  const skipNextSearch = useRef(false);

  const debouncedValue = useDebounce(clientName, 1000);

  useEffect(()=>{
    if (skipNextSearch.current) {
      skipNextSearch.current = false;
      return;
    }
    handleClientName(debouncedValue)
  }, [debouncedValue])

  // const [showEmailBtn, setShowEmailBtn] = useState(true);

  if (fromDate == "" || toDate == "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();
    if (CurrentMonth < 4) {
      const newYear = `04-01-${CurrentYear - 1}`;
      const date = `${current.getMonth() + 1
        }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    } else {
      const newYear = `04-01-${CurrentYear}`;
      const date = `${current.getMonth() + 1
        }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    }
  }

  async function searchApiDetail(e) {
    $(".write-search.contractList").addClass("show-result scroll-table");
    let payloadValue = {
      keyword: e.toUpperCase(),
      Status: "",
      PageNo: page,
      PageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axiosInstance.post(
        Client_Search.Search_URL,

        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(getSearchDetail?.data);

      if (res.message === "Client does not exist.") {
        setClientList([
          { clientname: "Client does not exist.", clientCode: null },
        ]);
      } else {
        if (scroll == true) {
          setClientList((prev) => {
            return [...prev, ...res.data.clients];
          });
          setServerError(false);
        } else {
          setClientList(res.data.clients);
          setServerError(false);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setScrollLoader(false);
    }
  }

  const handleClientName = (val) => {
    setScrollLoader(false);
    setData([]);
    // setFileType("");
    setNameError("");
    if (val) {
      setClientList([]);
      setScroll(false);
      
      if (val?.length > 3) {
        setPage(1);
        setClientList([]);
        setScroll(false);
        searchApiDetail(val);
      }
    } else {
      // alert("1")
      setClientList([]);
      setPage(1);
      setClientName("");
      setScroll(false);
      $(".write-search.contractList").removeClass("show-result");

      // searchApiDetail("")
    }
    $(".write-search.contractList-li").click(function () {
      $(".write-search.contractList").addClass("show-result scroll-table");
    });
  };

  const handleScroll = async () => {
    setScroll(true);
    const a = document.querySelector("#contractlist-scroll");
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      setPage((prev) => prev + 1);
      setScrollLoader(true);
      searchApiDetail(clientName);
    }
  };

  const getContractListReport = async (fileType, e) => {
    if (fileType === "mail") {
      setSmallLoaderMail(true);
      setLoader(false);
    }
    if (fileType === "grid") {
      setSmallLoaderMail(false);
      setLoader(true);
    }
    setServerError(false);
    let payloadValue = {
      clientCode: clientCode,
      fromDate: fromDate,
      toDate: toDate,
      // seg,
      fileType: fileType,
      reportType: selectedReportType,
      userContractName: e ? [e] : userFriendList.map(getFileNameFromSelectionKey),
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.GetContractList_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        
        if (fileType === "grid") {
          let data = res?.data.map((item) => {
            item.loader = false;
            return item;
          });
          setData(data);
          setAppliedReportType(selectedReportType);
        } else if (fileType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
          toast.success("File downloaded successfully");
        } else if (fileType === "mail") {
          toast.success("Email sent successfully.");
        }
      } else {
        if (fileType === "mail") {
          toast.error("Unable to send email. Please try again later.");
        } else if (fileType !== "grid") {
          toast.error(res?.message);
        }

        if (fileType === "grid") {
          setData([]);
          setServerError(res?.message);
        }
      }

      setClientNameError(false);
    } catch (error) {
      console.log(error);

      setServerError(error?.message);
      if (fileType === "mail") {
        toast.error("Unable to send email. Please try again later.");
      } else if (fileType !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderMail(false);
    }
  };

  const handleFromDateChange = (e) => {
    // setFileType("");
    setData("");
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setErrorResp("");
    setMailError("");
    setServerError("");
  };
  const handleToDateChange = (e) => {
    // setFileType("");
    setData("");
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setErrorResp("");
    setMailError("");
    setServerError("");
  };

  function clientSet(name, code, i) {
    // document.querySelector("#input1").value = data.clientCode;
    if (name === "Client does not exist.") {
      $(".write-search.contractList").addClass("show-result scroll-table");
    } else {
      skipNextSearch.current = true;
      $(".write-search.contractList").removeClass("show-result");
      setClientList([]);
      setClientName(name);
      setClientCode(code);
    }
  }

  // useEffect(() => {
  //   // var FromDateCombine = document.getElementById("FromDateCombine").value;
  //   // var ToDateCombine = document.getElementById("ToDateCombine").value;
  //   // if (FromDateCombine.length > 0 && ToDateCombine.length > 0) {

  //   // if (fileType != "") {
  //   getContractListReport("grid");
  //   // }

  //   // }
  // }, []);

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  // A custom date range is only allowed to span at most one calendar month.
  function exceedsOneMonth(from, to) {
    const fromM = moment(from, "MM-DD-YYYY");
    const toM = moment(to, "MM-DD-YYYY");
    return toM.isAfter(fromM.clone().add(1, "month"));
  }

  const handleOnClick = (e) => {
     if (e.currentTarget.value === "mail") {
       getMailData();
       return;
     }

    if (fromDate.length > 0 && toDate.length > 0 && clientName.length > 0) {
      setUserFriendList([]);
      setIsCheckAll(false);
      setClientNameError(false);
      if (e.target.value) {
        if(selectDuration){
          if (!selectedReportType) {
            setReportTypeError("Please select Report Type.");
            return;
          }

        setReportTypeError("");
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          if (selectDuration === "custom" && exceedsOneMonth(fromDate, toDate)) {
            setCheckDate(true);
            setErrorResp("Only one month data can be downloaded at a time.");
            return;
          }
          // setFileType(e.target.value)
          getContractListReport("grid");
          setErrorResp("");
          setMailError("");
        } else {
          setCheckDate(true);
          setErrorResp("Please Select Correct Date");
        }

      }
      else{
        setErrorResp("Please select Duration.");
      }
      }
    } else {
      setClientNameError(true);
      setNameError("Please select Client Name.");
    }
  };

  const handleEmailConfirmation = () => {
    setShowEmailConfirmation(false);
    getContractListReport("mail");
    setUserFriendList([]);
  };

  const handleEmailCancel = () => {
    setShowEmailConfirmation(false);
  };

  function getMailData() {
    setMailError("");
    if (clientName.length > 0) {
      if (userFriendList.length > 0) {
        setShowEmailConfirmation(true);
        // getContractListReport("mail");
        // setIsCheckAll(false)
        // setUserFriendList([]);
      } else {
        setMailError("Please Select at least one Contract Report");
        setErrorResp("");
      }
    } else {
      setNameError("Please select Client Name.");
    }
  }

  // There's no separate bulk-download button — clicking any row's download
  // icon downloads just that one file, unless one or more checkboxes are
  // already selected, in which case it downloads all selected files zipped
  // together instead (regardless of which row's icon was clicked).
  async function handleDownloadDocument(e, id) {
    const isBulk = userFriendList.length > 0;
    const oldData = [...data];
    const loaded = oldData.map((item, key) => {
      const selectionKey = getRowSelectionKey(item, key);
      item.loader = isBulk
        ? userFriendList.includes(selectionKey)
        : id === key;
      return item;
    });

    if (isBulk || e) {
      setData(loaded);
      setMailError("");

      if (isBulk) {
        await getContractListReport("pdf");
        setUserFriendList([]);
      } else {
        await getContractListReport("pdf", e);
      }

      const newloaded = data.map((item) => {
        item.loader = false;
        return item;
      });

      setData(newloaded);
    }
  }

  function selectAllDeleteSymbolList() {
    setIsCheckAll(!isCheckAll);
  }

  function handleSelectionChange(e) {
    setIsCheckAll(false);
    setMailError("");
    if (data.length >= userFriendList.length) {
      document.getElementById("select-all").checked = false;
    }
    const { value, checked } = e.target;
    if (checked) {
      setUserFriendList((preval) => [...preval, value]);
    } else {
      let newArr = userFriendList.filter((item) => item !== value);
      setUserFriendList(newArr);
    }
  }

  function getAllDeleteSymbol() {
    if (isCheckAll) {
      data.forEach((item, index) => {
        newArr.push(getRowSelectionKey(item, index));
      });
      setUserFriendList(newArr);
    } else {
      if (data.length <= userFriendList.length) {
        setUserFriendList([]);
        setUserFriendlyName([]);
      }
    }
  }

  const handleDownloadAllClick = async () => {
    if (userFriendList.length <= 1) {
      return;
    }

    const payload = {
      clientCode,
      reportType: appliedReportType,
      fileList : data.filter((item, index) => userFriendList.includes(getRowSelectionKey(item, index)))
                                      .map(item => ({FileName: item.FileName, FolderId: item.FolderId}))
    }
    const encryptedPayload = AESEncryption(payload);
    const { success, data : decryptedData } = await downloadAllStatementReport(encryptedPayload);
    if (success && decryptedData) {
      window.open(decryptedData.data?.fileUrl, "_self", "noopener,noreferrer");
    } else {
      toast.error(decryptedData?.message || "Failed to download reports. Please try again.");
    }
  }

  useEffect(() => {
    getAllDeleteSymbol();
  }, [isCheckAll]);

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const onChangeDuration = () => {
    setErrorResp("");
    setMailError("");
    setServerError("");
    setData("")

  }
  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box">
          <div>
            <h2 className="report-title">
              {Constants.Get_Contract_List_Report}
            </h2>
          </div>

          <div className="row input-field-wrapper">
            <div className="col-md-3 col-sm-4 col-12">
              <div className="form-group">
                <label className="form-label">
                  {Constants.Contract_Name}{" "}
                  <span className="required">*</span>{" "}
                </label>
                <div className="input-text-wrapper align-items-center">
                  <input
                    id="input1"
                    type="text"
                    className="input-text form-control"
                    placeholder="Search by Name/ Code"
                    value={clientName}
                    onChange={(e) => {
                      setClientName(e?.target?.value?.toUpperCase());
                      // handleClientName(e);
                    }}
                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                        .toUpperCase()
                        .replace(/[^A-Z0-9\s]/g, "")
                        .replace(/\s+/g, " ")
                        .trimStart()
                        .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                    }}
                  />

                  <ul
                    className="write-search contractList border-0"
                    id="contractlist-scroll"
                    onScroll={handleScroll}
                  >
                    {clientList.map((item, i) => (
                      <li
                        key={i}
                        onClick={() =>
                          clientSet(item.clientname, item.clientCode, i)
                        }
                      >
                        <div> {item.clientname}</div>
                        <div>{item.clientCode}</div>
                      </li>
                    ))}
                    {scrollLoader && (
                      <div className="loader-center">
                        <LoaderForSearch />
                      </div>
                    )}
                  </ul>
                </div>
                <span className="to-date-error">{nameError}</span>
              </div>
            </div>

            <div className="col-md-3 col-sm-4 col-12">
              <div className="form-group">
                <label className="form-label">
                  Report Type <span className="required">*</span>{" "}
                </label>

                <div className="input-text-wrapper align-items-center">
                  <select
                    id="reportType"
                    className={`input-text form-control${
                      selectedReportType ? " has-selected-value" : ""
                    }`}
                    value={selectedReportType}
                    onChange={(e) => {
                      setSelectedReportType(e.target.value);
                      setReportTypeError("");
                    }}
                  >
                    <option value="" disabled>
                      Please select report type
                    </option>
                    {REPORT_TYPES.map((item, index) => {
                      return (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      )
                    })}
                  </select>
                </div>

                {reportTypeError && (
                  <span className="to-date-error">{reportTypeError}</span>
                )}
              </div>
            </div>

            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <DurationChangeComponent
                  setCustomShow={setCustomShow}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  setSelectDuration={setSelectDuration}
                  selectDuration={selectDuration}
                  onChangeDuration={onChangeDuration}
                  required={true}
                />
              </div>
              {errorResp && !selectDuration && (
                <span className="duration-date-error">{errorResp}</span>
              )}
            </div>
            {customShow && (
              <div className="col-md-3 col-sm-4 col-6">
                <FromdateComponent
                  fromDate={handleFromDateChange}
                  formatDate={formatDate(fromDate)}
                  DateReverse={DateReverse}
                  clientWiseReportForCustomCalanderIcon={true}
                />
              </div>
            )}
            {customShow && (
              <div className="col-md-3 col-sm-4 col-6">
                <TodateComponent
                  toDate={handleToDateChange}
                  formatToDate={formatDate(toDate)}
                  DateReverse={DateReverse}
                  errorResponse={errorResp}
                  clientWiseReportForCustomCalanderIcon={true}
                />
              </div>
            )}
          </div>
          <div className="report-btn-wrapper">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <button
                className="generate-btn text-green mt-3"
                value="mail"
                onClick={getMailData}
                disabled={userFriendList.length === 0}
              >
                {smallLoaderMail ? (
                  <SmallLoader />
                ) : (
                  <>
                    <span className="icon-email"></span>
                    {"E-Mail"}
                  </>
                )}
              </button>

              {userFriendList.length > 1 && (
                <button
                  className="generate-btn text-green mt-3 download-btn"
                  value="download"
                  onClick={handleDownloadAllClick}
                >
                  {isDownloading ? (
                    <SmallLoader />
                  ) : (
                    <>
                      <span style={{background: "none", padding: "0", color: "inherit"}} className="icon-download"></span>
                      {"Download"}
                    </>
                  )} 
                </button>
              )}
            </div>

            <p className="mail-error">{mailError}</p>
          </div>
          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
            >
              {Constants.Search}
            </button>
          </div>
          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : (
              data.length > 0 && (
                <div>
                  <ContractListTable
                    data={data}
                    selectAllDeleteSymbolList={selectAllDeleteSymbolList}
                    handleSelectionChange={handleSelectionChange}
                    userFriendList={userFriendList}
                    handleDownloadDocument={handleDownloadDocument}
                    selectedReportType={appliedReportType}
                    clientCode={clientCode}
                    fromDate={fromDate}
                    toDate={toDate}
                  />
                </div>
              )
            )}
            {serverError && data.length === 0 && (
              <div className="report-error-message">
                {noDataFound(serverError)}
              </div>
            )}
          </div>

          {/* Email Confirmation Popup */}
          {showEmailConfirmation && (
            <div className="confirmation-popup">
              <div className="confirmation-popup-content">
                <p>Are you sure you want to send the email to the client?</p>

                <div className="confirmation-buttons">
                  <button type="button" onClick={handleEmailConfirmation}>
                    Yes
                  </button>

                  <button type="button" onClick={handleEmailCancel}>
                    No
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>
    </>
  );
}

export default ContractListSidebar;
